import { Container } from "@mui/material";

import NavigationToggle from "@/features/admin/components/navigation-toggle/NavigationToggle";
import { useOrganisationsQuery } from "@/features/admin/features/organisations/hooks/queries";
import AvatarCard, {
  AvatarCardType,
} from "@/features/shared/components/avatar-card/avatar-card";
import Fluid from "@/components/fluid/fluid";

const OrganisationOverviewPage = () => {
  const organisationQuery = useOrganisationsQuery();

  return (
    <Container sx={{ mt: { xs: 2, md: 6 } }}>
      <NavigationToggle />
      <Fluid width={280} spacing={4}>
        {organisationQuery.data?.map((organisation) => (
          <AvatarCard
            key={organisation.id}
            name={organisation.name}
            tags={[organisation.extranet.name]}
            to={"/admin/organisations/" + organisation.id}
            type={AvatarCardType.ORGANISATION}
          />
        ))}
      </Fluid>
    </Container>
  );
};

export default OrganisationOverviewPage;
